<hpf-game-form
        *ngIf="game"
        [game]="game"
        (create)="onCreate($event)"
    ></hpf-game-form>
<div *ngIf="!game" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>